/**
 * ChatPage Configuration
 * Centralized configuration for all ChatPage features and settings
 */

export const chatPageConfig = {
    // Layout settings
    layout: {
        showSidebar: false,
        showHeader: true,
        fullWidth: true,
        maxWidth: '1920px'
    },

    // Feature flags
    features: {
        tabs: true,              // Multi-tab system
        voiceInput: true,        // Voice input
        fileAttachment: true,    // File attachments
        agentSearch: true,       // Agent search modal
        multiAgent: true,        // Multiple agents support
        sync: true,              // Real-time sync
        markdown: true,          // Markdown support
        codeHighlight: true,     // Code syntax highlighting
        imagePreview: true       // Image preview
    },

    // Permissions
    permissions: {
        canCreateAgent: true,
        canDeleteMessages: true,
        canExportChat: true,
        canShareConversation: false
    },

    // UI Settings
    ui: {
        theme: 'dark',
        accentColor: '#3b82f6',
        messageAnimation: true,
        compactMode: false,
        showTimestamps: true,
        showAvatars: true
    },

    // Limits
    limits: {
        maxFileSize: 10 * 1024 * 1024, // 10MB
        maxMessageLength: 4000,
        maxTabsOpen: 5,
        maxAttachmentsPerMessage: 5
    }
} as const

export type ChatPageConfig = typeof chatPageConfig
